<template>
  <div class="container">
    <!-- etwas ist abgeschmiert darum wird einfehler angezeigt.
      Da dieses etwas auch die Sprachen(getMessages) sein kann wird hier noch auf übersetungen via t() verzichtet.
     -->
    <b-card class="col-12" v-if="$i18n.locale =='de'">
      dbmilch kann momentan nicht erreicht werden. <br>
      Bitte probieren Sie es später nochmals.  <br>
      Danke für Ihre Geduld. <br>
      <br>
      <b-btn  v-on:click="goBack" >Erneut probieren</b-btn> <br>
    </b-card>
    <b-card class="col-12" v-if="$i18n.locale =='fr'">
     dbmilch ne peut pas être atteint pour le moment. <br>
     Veuillez réessayer plus tard. <br>
      Merci pour votre patience <br><br>
      <br>
      <b-btn  v-on:click="goBack" >réessayer</b-btn> <br>
    </b-card>
    <b-card class="col-12" v-if="$i18n.locale =='if'">
      dbmilch non può essere raggiunto in questo momento. <br>
      Si prega di riprovare più tardi. <br>
      Grazie per la tua pazienza. <br><br>
      <br>
      <b-btn  v-on:click="goBack" >riprova</b-btn> <br>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "Timeout",
  props: {
    msg: String
  },
  methods: {
    goBack() {
      window.history.back();
    }
  }
};
</script>